/**
 * 全局dialog
 * @module store/modules/globalDialog
 * @see module:store/modules/globalDialog
 * @example
 */
export default {
  namespaced: true,
  state: {
    // 所有dialog
    list: []
  },
  getters: {
    // 获取dialog
    dialogList: (state) => state.list
  },
  mutations: {
    // 添加dialog
    addDialog(state, payload) {
      const id = payload.props?.id || new Date().getTime();
      state.list.push(Object.assign({ visible: true, id, show: true }, payload));
    },
    // 更新dialog参数
    updateDialog(state, payload) {
      const { id, propsData } = payload;
      const dialogIndex = state.list.findIndex((item) => item.id === id);
      if (dialogIndex !== -1) {
        // 合并更新数据，保留原有属性
        Object.assign(state.list[dialogIndex], { propsData });
      }
    },
    // 关闭dialog
    closeDialog(state, payload) {
      state.list.splice(payload.index, 1);
      if (!payload.isNativeClose) payload.callBack && payload.callBack();
    },
    // 关闭所有dialog
    closeAllDialog(state) {
      state.list = [];
    }
  },
  actions: {}
};
